    <template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <span style="  font-size:12px;margin-right:10px;margin-left:5px;font-weight:600;white-space:nowrap;flex-shrink:0;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select @change="selChg" v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:130px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :disabled="item.key=='adddttm'" :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input  :placeholder="input_hold" clearable v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px;background:white;border:1px solid #389 " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <template slot ="append">
                        <el-button size="small" slot="append" icon="iconfont icon-gaojichazhao2" @click="inputQry" class="custom-button" ></el-button>
                    </template>
                </el-input> 
       
                <el-dropdown @command="dropSel"   size="small" style="margin-left:5px;">
                    <el-button type="danger" size="small" style="height:31px">
                        {{ $LANG('0337', '更多') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item icon="iconfont icon-daochu" command="expdata" style="line-height:40px;height:40px">{{ $LANG('0172', '导出数据') }}</el-dropdown-item>
                        <el-dropdown-item icon="iconfont icon-ziyuan" command="fldset" style="line-height:40px;height:40px">{{ $LANG('0683', '字段设置') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="subHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"                   
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"                    
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    v-loading="v_loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    id="motor_rep"
                    ref="tableRef"
                >
 
            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
  
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 字段设置 -->
        <el-dialog class="pub_dialog" v-dialogDrag v-if="setWin" :visible.sync="setWin" width="480px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段显示设置</span>
            </div>
            <easy-win v-bind:colArr ="fldArr" @child-exit="setWin=false" @child-sure="setOk"></easy-win>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="display:flex">
                <div style="width:170px; border-right:3px solid #ccc;height:88vh">
                    <div class="text_div">{{ $LANG('0547', '产品编码') }}: {{formRow['IDNO']}}</div>
 
                    <div class="text_div">{{ $LANG('0626', '单据状态') }}:
                        <el-tag  v-if=" formRow['STFG_SPEC']=='Y'" size="small" type="success" effect="dark">{{ $LANG('1976', '已审核') }}</el-tag>
                        <el-tag  v-else size="small" type="info" effect="dark">{{ $LANG('1953', '未审') }}</el-tag>
                    </div>
 
                    <div v-for="(item,index) in menuArr " :key="index" style="margin-top:10px">
                        <div  class="oneMenu">
                            <div  :class="{active:v_tabName===item.FLDNO}" @click="itemClick(item.FLDNO)">
                                <i class="iconfont icon-dingdan1" style="font-size:18px;margin-right:5px;color:#ccc;margin-left:2px"></i>
                                {{item.FLDNM}}
                            </div> 
                        </div>
                    </div>
                    <el-image fit="scale-down"  style="width:98%;height:140px;margin-top:50px; " :src="formRow['IMGPATH']" :preview-src-list="[formRow['IMGPATH']]">                 
                        <div   slot="error" >
                            <!-- <i class="el-icon-picture-outline"></i> -->
                            <el-tag type="danger" style="font-size:18px;border:2px solid red">{{ $LANG('0111', '暂无图片') }}</el-tag>
                        </div>
                    </el-image>
                </div>
                <div style="height:88vh;overflow-y:auto;width:calc(100% - 170px); ">
                    <Form :model="formRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in tabCol" :key="index" >
                            <FormItem   :label="$translate.getColTitle(item, $store.state.lang)"  :class=" item.edcss=='textarea'?'item-one':'item-width'" v-if="item.fhide==='N'" :prop="item.key"  >
                                <el-date-picker size="small" :disabled="saveFlag||item.disabled==='Y'?true:false" type="date"  v-if="item.edcss==='date'" v-model="formRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-checkbox class="large-checkbox" size="small"  :disabled="saveFlag||item.disabled==='Y'?true:false" border v-else-if="item.edcss=='checkbox'"  true-label="Y"  false-label="N" v-model="formRow[item.key]" style="width:100%;"> &nbsp;</el-checkbox> 
                                <el-input type="number" :disabled="saveFlag||item.disabled==='Y'?true:false" @keydown.native="e=>e.returnValue=(['e','E','+' ].includes(e.key))?false:e.returnValue"   v-else-if="item.edcss=='number'" size="small" v-model="formRow[item.key]" style="width:100%"> </el-input> 
                                <el-input resize="none" :disabled="saveFlag||item.disabled==='Y'?true:false" v-else-if="item.edcss==='textarea'" type="textarea" :rows="3"  :placeholder="$LANG('1670', '请输入内容')" v-model="formRow[item.key]" maxlength="2000" show-word-limit ></el-input>
    
                                <el-select size="small" @change="comboChg" :disabled="saveFlag||item.disabled==='Y'?true:false" v-else-if="item.edcss==='select'" v-model="formRow[item.key]"  filterable style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                </el-select>
                                <el-input size="small" :placeholder="item.holder" :disabled="saveFlag||item.disabled==='Y'?true:false" type="text" v-else   v-model="formRow[item.key]" ></el-input>
                            </FormItem>
                        </span>
                    </Form>  
 
                    <div v-show="v_tabName=='one'" style="margin-top:4px">
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow"> {{ $LANG('1387', '文件修订记录表') }}</span>
                            <el-button :disabled="saveFlag" @click="dtlAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="dtlData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="220" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refdtl"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <el-link v-else-if="item.key=='IMGPATH' " :underline="false"  > 
                                            <el-image fit="scale-down"  style="width:100%;height:30px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                            </el-image>
                                        </el-link>
                                        <el-input resize="none" disabled v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <el-input type="number"   @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <el-link v-else-if="item.key=='IMGPATH' " :underline="false"  > 
                                            <el-image fit="scale-down"  style="width:100%;height:30px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                            </el-image>
                                        </el-link>
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">
                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="dtlDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                 
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow"> {{ $LANG('0884', '电机类型') }}</span>
                            <el-button :disabled="saveFlag" @click="tyAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="tyData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="180" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refty"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in tyCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input type="number"   @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="tyDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow"> {{ $LANG('1933', '产品族(颜色或者其它细微变化，不影响电气参数及性能') }}）</span>
                            <el-button :disabled="saveFlag" @click="reqAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="matData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="240" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refreq"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in reqCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-link v-if="item.key=='IMGPATH' " :underline="false"  > 
                                            <el-image fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                            </el-image>
                                        </el-link>
                                        <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='Y'" size="mini" type="success" effect="dark">{{ $LANG('2047', '是') }}</el-tag>
                                        <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='N'" size="mini" type="info" effect="dark">{{ $LANG('2044', '否') }}</el-tag>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-link v-else-if="item.key=='IMGPATH' " :underline="false"  > 
                                            <el-image fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                            </el-image>
                                        </el-link>
                                        <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)"  v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>  
                                        <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='Y'" size="mini" type="success" effect="dark">{{ $LANG('2047', '是') }}</el-tag>
                                        <el-tag  v-else-if="item.edcss=='checkbox'&&scope.row[item.key]=='N'" size="mini" type="info" effect="dark">{{ $LANG('2044', '否') }}</el-tag>
                                        <el-input type="number"   @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="reqDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-show="v_tabName=='two'" style="margin-top:4px">
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow"> {{ $LANG('0112', '曲线性能') }}</span>
                            <el-button :disabled="saveFlag" @click="perfAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="perfData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="150" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refperf"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in perfCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input type="number"   @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="perfDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">{{ $LANG('1055', '产品规格图') }}</span>
                            <el-button :disabled="saveFlag" @click="specAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="specData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :min-height="440" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refspec"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in specCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-link v-if="item.key=='FILEPATH' " :underline="false"  > 
                                            <el-image fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                            </el-image>
                                        </el-link>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-link v-else-if="item.key=='FILEPATH' " :underline="false"  > 
                                            <el-image v-if="!!scope.row[item.key]" fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline" style="font-size:30px;margin-top:10px"></i></div>
                                            </el-image>
                                            <Upload v-else
                                                ref="upload"
                                                name="upfile"
                                                :data="uploadData"
                                                :show-upload-list="false"
                                                :before-upload="beforeImgFile"
                                                :on-success="successImgFile"
                                                :with-credentials="true"                            
                                                :format="['jpg','jpeg','png','pdf' ]"
                                                :max-size="20480"
                                                :on-format-error="handleFormatError"
                                                :on-exceeded-size="handleMaxSize"
                                                type="drag"                      
                                                :on-progress="handleProgress"
                                                :action="uploadUrl"
                                                style="display: inline-block;width:98% ">                           
                                                <div style="padding: 1px 0;margin-top:10px">
                                                    <el-button size="small" @click="upClick(scope.row,scope.$index)" type="primary">{{ $LANG('0854', '点击上传') }}</el-button>
                                                </div>                                                       
                                            </Upload>     
                                        </el-link> 
                                        <el-select filterable  v-else-if="item.key=='FILETY'" size="mini" v-model="scope.row[item.key]" style="width:100%"> 
                                            <el-option  v-for="(item,index) in fileTy" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="imgDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-show="v_tabName=='three'" style="margin-top:4px">
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">{{ $LANG('0047', '扭力测试') }}</span>
                            <el-button :disabled="saveFlag" @click="testAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="testData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="180" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="reftest"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in testCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="testDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">{{ $LANG('0853', '温升测试') }}</span>
                            <el-button :disabled="saveFlag" @click="tempAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="tempData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="250" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="reftemp"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in tempCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="tempDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table> 
                    </div>
                    <div v-show="v_tabName=='four'" style="margin-top:4px">
                        <div class="one-div" style="height:30px;">
                            <span class="oneRow">{{ $LANG('1544', '电气安全与绝缘性能') }}</span>
                        </div>
                        <span v-for="item  in safeArr.filter(item=>item.SUBNO2=='电气安全')" :key="item.CODE" >
                            <div style="min-height:35px;line-height:35px;fon-size:12px;display:flex"> 
                                <div style="width:200px;margin-left:5px;border-bottom:1px dashed #ccc ">{{item.CNAME}}</div>
                                <div style="width:850px;margin-left:5px;border-bottom:1px dashed #ccc">{{item.SUBNO}}</div>
                                <el-input  :placeholder="saveFlag ? '' : $LANG('1719', '请输入测试结果')" @input="handleInput()"  :disabled="saveFlag" v-model="item.STREASON"  style="padding:0px;margin-top:3px;width:150px;height:30px; " size="small"></el-input>
                            </div>
                        </span>
                        <div class="one-div" style="height:30px;margin-top:4px;">
                            <span class="oneRow">{{ $LANG('1848', '电机寿命与运行稳定性测试') }}</span>
                        </div>
                        <span v-for="item in safeArr.filter(item=>item.SUBNO2=='电机寿命')" :key="item.CODE" >
                            <div style="min-height:35px;line-height:35px;fon-size:12px;display:flex"> 
                                <div style="width:200px;margin-left:5px;border-bottom:1px dashed #ccc ">{{item.CNAME}}</div>
                                <div style="width:850px;margin-left:5px;border-bottom:1px dashed #ccc">{{item.SUBNO}}</div>
                                <el-input  :placeholder="saveFlag ? '' : $LANG('1719', '请输入测试结果')" @input="handleInput()"   :disabled="saveFlag" v-model="item.STREASON"  style="padding:0px;margin-top:3px;width:150px;height:30px; " size="small"></el-input>
                            </div>
                        </span>
                        <div class="one-div" style="height:30px;margin-top:4px;">
                            <span class="oneRow">{{ $LANG('1425', '防火与阻燃性能') }}</span>
                        </div>
                        <span v-for="item in safeArr.filter(item=>item.SUBNO2=='防火')" :key="item.CODE" >
                            <div style="min-height:35px;line-height:35px;fon-size:12px;display:flex"> 
                                <div style="width:200px;margin-left:5px;border-bottom:1px dashed #ccc ">{{item.CNAME}}</div>
                                <div style="width:850px;margin-left:5px;border-bottom:1px dashed #ccc">{{item.SUBNO}}</div>
                                <el-input :placeholder="saveFlag ? '' : $LANG('1719', '请输入测试结果')" @input="handleInput()"   :disabled="saveFlag" v-model="item.STREASON"  style="padding:0px;margin-top:3px;width:150px;height:30px; " size="small"></el-input>
                            </div>
                        </span>
                        <div class="one-div" style="height:30px;margin-top:4px;">
                            <span class="oneRow">{{ $LANG('1392', '机械安全与防护') }}</span>
                        </div>
                        <span v-for="item in safeArr.filter(item=>item.SUBNO2=='机械安全')" :key="item.CODE" >
                            <div style="min-height:35px;line-height:35px;fon-size:12px;display:flex"> 
                                <div style="width:200px;margin-left:5px;border-bottom:1px dashed #ccc ">{{item.CNAME}}</div>
                                <div style="width:850px;margin-left:5px;border-bottom:1px dashed #ccc">{{item.SUBNO}}</div>
                                <el-input  :placeholder="saveFlag ? '' : $LANG('1719', '请输入测试结果')" @input="handleInput()"   :disabled="saveFlag" v-model="item.STREASON"  style="padding:0px;margin-top:3px;width:150px;height:30px; " size="small"></el-input>
                            </div>
                        </span>
                        <div class="one-div" style="height:30px;margin-top:4px;">
                            <span class="oneRow">{{ $LANG('0985', '运输安全') }}</span>
                        </div>
                        <!-- <div style="height:30px;line-height:30px;fon-size:12px;display:flex;border-bottom:2px solid #409eff"> 
                            <div style="width:200px;margin-left:5px;font-weight:600;color:#333">测试项目</div>
                            <div style="width:700px;margin-left:5px;font-weight:600;color:#333 ">项目描述</div>
                            <div style="width:200px;margin-left:5px;font-weight:600;color:#333 ">测试结果</div>
                        </div> -->
                        <span v-for="item in safeArr.filter(item=>item.SUBNO2=='运输')" :key="item.CODE" >
                            <div style="min-height:35px;line-height:35px;fon-size:12px;display:flex"> 
                                <div style="width:200px;margin-left:5px;border-bottom:1px dashed #ccc ">{{item.CNAME}}</div>
                                <div style="width:850px;margin-left:5px;border-bottom:1px dashed #ccc">{{item.SUBNO}}</div>
                                <el-input  :placeholder="saveFlag ? '' : $LANG('1719', '请输入测试结果')" @input="handleInput()"  :disabled="saveFlag" v-model="item.STREASON"  style="padding:0px;margin-top:3px;width:150px;height:30px; " size="small"></el-input>
                            </div>
                        </span>
                    </div>
                    <div v-show="v_tabName=='five'" style="margin-top:4px">
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow"> {{ $LANG('0621', '包装信息') }}</span>
                            <el-button :disabled="saveFlag" @click="pkgAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="pkgData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="180" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refpkg"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in pkgCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input type="number"   @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="pkgDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">{{ $LANG('1072', '包装附件图') }}</span>
                            <el-button :disabled="saveFlag" @click="attAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="imgData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :min-height="440" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refatt"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in specCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-link v-if="item.key=='FILEPATH' " :underline="false"  > 
                                            <el-image fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                            </el-image>
                                        </el-link>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >   
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-link v-else-if="item.key=='FILEPATH' " :underline="false"  > 
                                            <el-image v-if="!!scope.row[item.key]" fit="scale-down"  style="width:100%;height:40px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                                <div   slot="error" ><i class="el-icon-picture-outline" style="font-size:30px;margin-top:10px"></i></div>
                                            </el-image>
                                            <Upload v-else
                                                ref="upload"
                                                name="upfile"
                                                :data="uploadData"
                                                :show-upload-list="false"
                                                :before-upload="beforeImgFile"
                                                :on-success="successPkgFile"
                                                :with-credentials="true"                            
                                                :format="['jpg','jpeg','png','pdf' ]"
                                                :max-size="20480"
                                                :on-format-error="handleFormatError"
                                                :on-exceeded-size="handleMaxSize"
                                                type="drag"                      
                                                :on-progress="handleProgress"
                                                :action="uploadUrl"
                                                style="display: inline-block;width:98% ">                           
                                                <div style="padding: 1px 0;margin-top:10px">
                                                    <el-button size="small" @click="imgClick(scope.row,scope.$index)" type="primary">{{ $LANG('0854', '点击上传') }}</el-button>
                                                </div>                                                       
                                            </Upload>     
                                        </el-link> 
                                        <el-select  filterable v-else-if="item.key=='FILETY'" size="mini" v-model="scope.row[item.key]" style="width:100%"> 
                                            <el-option  v-for="(item,index) in fileTy" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="phoDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-show="v_tabName=='six'" style="margin-top:4px">
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">{{ $LANG('0946', '认证信息') }}</span>
                            <el-button :disabled="saveFlag" @click="certAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="certData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="180" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refcert"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in certCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >    
                                        <el-checkbox v-if="item.edcss=='checkbox'"  true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>                
                                        <el-date-picker size="mini" type="date"  v-else-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <el-select v-else-if="item.key=='HOLDER'" size="mini" v-model="scope.row[item.key]" style="width:100%"> 
                                            <el-option  v-for="(item,index) in holdArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                                        </el-select> 
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="certDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">CDF</span> 
                            <el-button :disabled="saveFlag" @click="cdfAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="cdfData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="250" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refcdf"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in cdfCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="2"  :placeholder="$LANG('1670', '请输入内容')" v-model="scope.row[item.key]"></el-input>
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="cdfDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table> 
                    </div>
                    <div v-show="v_tabName=='seven'" style="margin-top:4px">
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">SOP{{ $LANG('0669', '基础信息') }}</span>
                        </div>
                        <Form :model="formRow" :label-width="110"   label-position="right" inline  >  
                            <FormItem   :label="$LANG('0079', '文件编号')"  :class="'item-width'" prop="SOP_FILENO"  >
                                <el-input size="small"  :disabled="saveFlag " type="text"   v-model="formRow['SOP_FILENO']" ></el-input>
                            </FormItem>
                            <FormItem   :label="$LANG('0916', '编制日期')"  :class="'item-width'" prop="SOP_DTTM"  >
                                <el-date-picker size="small" :disabled="saveFlag" type="date"  v-model="formRow['SOP_DTTM']" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            </FormItem>
                            <FormItem   :label="$LANG('0793', '适用产品名称及编号')"  :class="'item-width'" prop="SOP_MATNM"  >
                                <el-input size="small"  :disabled="saveFlag " type="text"   v-model="formRow['SOP_MATNM']" ></el-input>
                            </FormItem>
                            <FormItem   :label="$LANG('0414', '页数')"  :class="'item-width'" prop="SOP_PAGE"  >
                                <el-input size="small"  :disabled="saveFlag " type="number" v-model="formRow['SOP_PAGE']"  @keydown.native="e=>e.returnValue=(['e','E','+' ].includes(e.key))?false:e.returnValue"></el-input>
                            </FormItem>
                            <FormItem   :label="$LANG('0356', '版本')"  :class="'item-width'" prop="SOP_VER"  >
                                <el-input size="small"  :disabled="saveFlag " type="text"   v-model="formRow['SOP_VER']" ></el-input>
                            </FormItem>
                            <FormItem   :label="$LANG('0294', '备注')"  :class="'item-width'" prop="SOP_RMK"  >
                                <el-input size="small"  :disabled="saveFlag " type="text"   v-model="formRow['SOP_RMK']" ></el-input>
                            </FormItem>
                        </Form> 
                        <div class="one-div" style="height:32px;">
                            <span class="oneRow">{{ $LANG('0715', '工序信息') }}</span>
                            <el-button :disabled="saveFlag" @click="jobAdd" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:20px;border:1px solid green;white-space:nowrap;">
                                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>{{ $LANG('0138', '新增') }}
                            </el-button>
                        </div>
                        <el-table  :data="jobData" 
                            border                            
                            size="small"
                            cell-class-name="clearPadding"                  
                            :header-cell-style="{ 'color':'#389','text-align':'center'}"
                            :cell-style="{padding:'3px',color:'black','font-size':'12px'}"
                            :row-class-name="tabRowClass" 
                            :height="300" 
                            :row-key="getRowKey"
                            class="custom-table-border"
                            ref="refjob"
                            highlight-current-row
                            style="overflow:auto;margin-top:-8px;"> 
                            <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"  ></el-table-column>
                            <el-table-column   v-for="(item,index ) in jobCol.filter(item=>item.thide=='N') " :key="index"
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"  
                                :fixed="item.fix=='Y'" 
                                resizable                              
                                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                                :min-width="item.width">                       
                                <template slot-scope="scope">
                                    <span v-if ="saveFlag" >
                                        <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                        <span v-else v-text="scope.row[item.key]"></span> 
                                    </span>
                                    <span v-else >                    
                                        <el-date-picker size="mini" type="date"  v-if="item.edcss==='date'" v-model="scope.row[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                        <el-input   @focus="inputBtn(scope.row,scope.$index,item.key)"  v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <el-input type="number"   @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                        <el-input type="text"  v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </span>    
                                </template>           
                            </el-table-column>  
                            <el-table-column
                                fixed="right"
                                :label="$LANG('0870', '状态操作')"
                                align="center"
                                width="70">
                                <template slot-scope="scope">                
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link :disabled="saveFlag"  @click="jobDel(scope.row, scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('0131', '删除') }}</span></el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="saveFlag" type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag  v-if="btnWin" :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
 
    </div>
</template>
<script>
import {getBaseData,getTabColOrData,getTab_Column} from '../../api/user'; 
import { getDate,getDate2} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue' 
import repWin from '../datamgt/repWin.vue' 
import easyWin from '../datamgt/easy_field.vue'
 
export default {
    name:'motor_report',
    data () {
        return {
            matData:[],
            v_row:{},
            v_table:'',
            reqCol:[],
            menuArr:[{FLDNO:'one',FLDNM:this.$LANG('0544', '产品概述')},{FLDNO:'two',FLDNM:this.$LANG('0548', '产品规格')},{FLDNO:'three',FLDNM:this.$LANG('1305', '综合性能分析')},{FLDNO:'four',FLDNM:this.$LANG('1369', '寿命可靠性测试').replace(String.fromCharCode(23551,21629,21487,38752,24615), String.fromCharCode(23551,21629,47,21487,38752,24615))},{FLDNO:'five',FLDNM:this.$LANG('1205', '包装运输贮存')},{FLDNO:'six',FLDNM:this.$LANG('0389', '认证')},{FLDNO:'seven',FLDNM:this.$LANG('1059', '作业指导书')}],
            tyCol :[],
            v_key2 :'',
            loadWin :false ,
            jobArr:[],
            v_value2 :'',
            tyData:[],
            tableCol:[],
            ruleValidate:{},
            specCol:[],
            imgWin:false,
            specData:[],
            v_commit :true,
            promptWin:false,
            formRow:{},
            comboArr:[],
            dtlCol:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容')+'...',
            t_cond:'',
            selparam:'IDNO',
            txtparam:'',
            v_dttm:'',
            v_todttm:'',
            allList:[],
            perfData:[],
            rowIdseq:'',
            tabData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //作废权限
            delBool:false,  
            v_page:1,
            saveFlag:false,
            v_loading:false,
            dtlData:[],
            fileTy:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [50,500,1000],   
            dataCount:0,
            pageSize:50,   
            tabCol:[],
            operArr:[],
            oper:'like',
            v_key:'',           
            v_idseq:'',
            delDtlArr:[],
            delReqArr:[],
            delPerfData:[],
            delTestData:[],
            delTempData:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:'',
            v_tabName:'one',
            delTyArr:[],
            vueCol:[],
            notNull:[],
            v_tabRow:{},
            v_tabIndex:'',
            v_imgRow:{},
            v_imgIndex:'',
            v_pkgIndex:'',
            v_pkgRow:{},    
            pageIndex:1,
            setWin:false,
            fldArr:[],
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            columnWidthResizeOption: {
                enable: true, // default false
                minWidth: 20, // column resize min width
                // column size change
                sizeChange: ({ column, differWidth, columnWidth }) => {
                    const targetCol =this.vueCol.find(item=>item.key==column.key)
                    if (targetCol){
                        targetCol.width =columnWidth
                    }
                },
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_sort:'asc',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            perfCol:[],
            fileName:'',
            delImg:[],
            btnWin:false,
            testCol:[],
            testData:[],
            tempCol:[],
            tempData:[],
            safeArr:[],
            pkgCol:[],
            pkgData:[],
            delPkgData:[],
            delPkgImg:[],
            imgData:[],
            certData:[],
            certCol:[],
            delCertData:[],
            holdArr:[],
            cdfData:[],
            cdfCol:[],
            delCdfData:[],
            jobData:[],
            jobCol:[],  
            delJobData:[],
            matCol:[],
        }
    },
    components: {
      pubWin,
      repWin,
      easyWin,
 
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 395) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        //报表清单
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','440642','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        getBaseData(this.v_url,'PARENTNO','473873','','','v_sys_base','').then(res=>{
            this.fileTy =res.result
        })
        getBaseData(this.v_url,'PARENTNO','474281','','','v_sys_base','').then(res=>{
            this.holdArr =res.result
        })
        getBaseData(this.v_url,'PARENTNO','474168','','','v_sys_base','').then(res=>{
            this.safeArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','440642','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })   
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','440642','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
    },
    created () {
        if (this.v_username && this.v_corpid){
            this.loadTableColumns()
            this.getTabField() //表列集合
            this.getTabList('')
            this.showkey()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        handleInput(){
            this.$forceUpdate() //强制更新页面，解决v-model在数组中无法响应式更新的问题
        },
        inputBtn(row,index, key){   
            this.v_key =key         
            if (key=='MATNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='V_BS_MAT_MOTOR'
                this.tableCol =this.tabCol
                this.v_key2 =''
                this.v_value2 = ''
                this.btnWin =true
            }else if (key=='JOBNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='V_BS_JOB'
                this.tableCol =this.jobArr
                this.v_key2 =''
                this.v_value2 = ''
                this.btnWin =true
            }else if (key=='PMATNO'){
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='V_BS_MATQRY'
                this.tableCol =this.matCol
                this.v_key2 ='MODELNO'
                this.v_value2 = 'MAT'
                this.btnWin =true
            }
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.matData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{MATIDSEQ:obj['IDSEQ'],MATNO:obj['IDNO'],IMGPATH:obj['IMGPATH'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],SPEC_MKT:obj['SPEC_MKT'],SPEC_CLNT:obj['SPEC_CLNT'],SPEC_CERT:obj['SPEC_CERT']} ))
            }else if (this.v_key =='JOBNO'){
                this.jobData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ JOBNO:obj['IDNO'], JOBNM:obj['JOBNM'] } ))
            }else if (this.v_key =='PMATNO'){
                this.jobData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ PMATNO:obj['IDNO'], MATNM:obj['MATNM'],MATDESC:obj['MATDESC'] } ))
            }
            this.btnWin =false
        },
        itemClick(val){
            this.v_tabName =val     
        },
        phoDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delPkgImg.push({IDSEQ:row['IDSEQ'],LSTSEQ:row['LSTSEQ'],FILEPATH:row['FILEPATH']}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //图片删除，操作数组
        imgDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:row['IDSEQ'],LSTSEQ:row['LSTSEQ'],FILEPATH:row['FILEPATH']}) 
                this.specData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name + this.$LANG('1431', ' 是不正确, 请选择pdf或图片格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + this.$LANG('1561', '文件太大， 不能超出') + '20M'
        },
        upClick(row,index){
            this.v_imgRow =row
            this.v_imgIndex =index
        },
        imgClick(row,index){
            this.v_pkgRow =row
            this.v_pkgIndex =index
        },
        successPkgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.splice(this.v_pkgIndex,1,Object.assign(this.v_pkgRow,{FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name, PATH:'/web/web_images/material/'+res.result }))                   
            }else{0
                this.promptWin =true
                this.prompt =res.result
            }                   
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.specData.splice(this.v_imgIndex,1,Object.assign(this.v_imgRow,{FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name, PATH:'/web/web_images/material/'+res.result }))                   
            }else{0
                this.promptWin =true
                this.prompt =res.result
            }                   
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= getDate('year')+'-motor'     
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        specAdd(){
            let v_row ={}
            this.specCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.specData.push(Object.assign(v_row,{IMGTY:'SPEC'}) )
            this.$nextTick(()=>{
                this.$refs['refspec'].doLayout()
            }) 
        },
        attAdd(){
            let v_row ={}
            this.specCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.imgData.push(Object.assign(v_row,{IMGTY:'PKG'}) )
            this.$nextTick(()=>{
                this.$refs['refatt'].doLayout()
            }) 
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
        },
        testAdd(){
            let v_row ={}
            this.testCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.testData.push( v_row )
            this.$nextTick(()=>{
                this.$refs['reftest'].doLayout()
            }) 
        },
        certAdd(){
            let v_row ={}
            this.certCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.certData.push( v_row )
            this.$nextTick(()=>{
                this.$refs['refcert'].doLayout()
            }) 
        },
        tempAdd(){
            let v_row ={}
            this.tempCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.tempData.push( v_row )
            this.$nextTick(()=>{
                this.$refs['reftemp'].doLayout()
            }) 
        },
        reqAdd(){
            let v_row ={}
            this.reqCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.matData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refreq'].doLayout()
            }) 
        },
        tyAdd(){
            let v_row ={}
            this.tyCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.tyData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refty'].doLayout()
            }) 
        },
        perfAdd(){
            let v_row ={}
            this.perfCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.perfData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refperf'].doLayout()
            }) 
        },
        pkgAdd(){
            let v_row ={}
            this.pkgCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.pkgData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refpkg'].doLayout()
            }) 
        },
        cdfAdd(){
            let v_row ={}
            this.cdfCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.cdfData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refcdf'].doLayout()
            }) 
        },
        jobAdd(){
            let v_row ={}
            this.jobCol.forEach(item=>{
                v_row[item.key] =''
            })  
            this.jobData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refjob'].doLayout()
            }) 
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },

        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='MOVEQTY'||column.property==='OKQTY'||column.property==='ZQTY' ){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
 
        reqDel(row,index){
            this.delReqArr.push(JSON.parse(JSON.stringify(row)))
            this.matData.splice(index,1)      
        },
        tyDel(row,index){
            this.delTyArr.push(JSON.parse(JSON.stringify(row)))
            this.tyData.splice(index,1)      
        },
        dtlDel(row,index){
            this.delDtlArr.push(JSON.parse(JSON.stringify(row)))
            this.dtlData.splice(index,1)      
        },
        perfDel(row,index){
            this.delPerfData.push(JSON.parse(JSON.stringify(row)))
            this.perfData.splice(index,1)      
        },
        testDel(row,index){
            this.delTestData.push(JSON.parse(JSON.stringify(row)))
            this.testData.splice(index,1)      
        },
        tempDel(row,index){
            this.delTempData.push(JSON.parse(JSON.stringify(row)))
            this.tempData.splice(index,1)      
        },  
        cdfDel(row,index){
            this.delCdfData.push(JSON.parse(JSON.stringify(row)))
            this.cdfData.splice(index,1)      
        },
        pkgDel(row,index){
            this.delPkgData.push(JSON.parse(JSON.stringify(row)))
            this.pkgData.splice(index,1)      
        }, 
        certDel(row,index){
            this.delCertData.push(JSON.parse(JSON.stringify(row)))
            this.certData.splice(index,1)      
        }, 
        jobDel(row,index){
            this.delJobData.push(JSON.parse(JSON.stringify(row)))
            this.jobData.splice(index,1)      
        },
        //保存记录
        saveRec(){
            //console.log(JSON.stringify(this.safeArr))
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })           
            //发起保存请求 
            if (this.stfgBool &&this.v_commit) { 
                this.loadWin =true
                let v_safeData= this.safeArr.map(item=>{return {CODE:item.CODE,CNAME:item.CNAME,SUBNO:item.SUBNO,STREASON:item.STREASON,SUBNO2:item.SUBNO2,LSTSEQ:item.LSTSEQ,IDSEQ:''} })
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(this.formRow), p_table:'bs_mat',frmid:''},
                }).then(async (res)=>{      
                    if(res.code ==='200')  {  
                        this.v_commit =false
                        let v_idseq =res.idseq
                        // 批量保存  res.idseq
                        await Promise.all([
                            // 明细批量保存 
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'MAT_NOTE',p_idseq:v_idseq,p_action:'S' },
                            }) ,
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.matData), p_table:'MAT_LIST',p_idseq:v_idseq,p_action:'S' },
                            }) ,
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.tyData), p_table:'SPEC_TYPE',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.specData), p_table:'SPEC_IMG',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.imgData), p_table:'SPEC_IMG',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.perfData), p_table:'MAT_PERF',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.testData), p_table:'MAT_TEST',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.tempData), p_table:'MAT_TEMP',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(v_safeData), p_table:'MAT_LIFE',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.pkgData), p_table:'MAT_PACK',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.certData), p_table:'MAT_CERT',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.cdfData), p_table:'MAT_CDF',p_idseq:v_idseq,p_action:'S' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.jobData), p_table:'MAT_JOB',p_idseq:v_idseq,p_action:'S' },
                            }),

                            //明细记录删除
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delReqArr), p_table:'MAT_LIST',p_idseq:v_idseq,p_action:'D' },
                            }) ,
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delTyArr), p_table:'SPEC_TYPE',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delDtlArr), p_table:'MAT_NOTE',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delPerfData), p_table:'MAT_PERF',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delTestData), p_table:'MAT_TEST',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delTempData), p_table:'MAT_TEMP',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delPkgData), p_table:'MAT_PACK',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delCertData), p_table:'MAT_CERT',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delCdfData), p_table:'MAT_CDF',p_idseq:v_idseq,p_action:'D' },
                            }),
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delJobData), p_table:'MAT_JOB',p_idseq:v_idseq,p_action:'D' },
                            }) ,
                        ]).catch(res=>{
                            this.promptWin=true
                            this.prompt=res.result
                        })
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'SPEC_IMG'},
                            }).then(res=>{          
                                //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                    this.$axios({
                                        method: 'post',
                                        url: '/xuper_oss/ftpDelete',
                                        data: {p_path:'/volume1'+v_path},
                                    }).then(res=>{ 
                                        console.log(res.result)
                                    })
                                }
                                     
                            })        
                        }  
                        for(let k=0;k<this.delPkgImg.length;k++){
                            let v_filepath=this.delPkgImg[k]['FILEPATH'],v_path=this.delPkgImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delPkgImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delPkgImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delPkgImg[k]['FILEPATH'],p_table:'SPEC_IMG'},
                            }).then(res=>{          
                                //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                    this.$axios({
                                        method: 'post',
                                        url: '/xuper_oss/ftpDelete',
                                        data: {p_path:'/volume1'+v_path},
                                    }).then(res=>{ 
                                        console.log(res.result)
                                    })
                                }
                                     
                            })        
                        }  
                        this.loadWin =false
                        this.addWin =false   
                        this.inputQry()
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            
            } //
           
        },
 
        //编辑记录
        editRec(row,val,index){
            this.v_idseq= row['IDSEQ']
            this.loadWin =true
            if (val =='Y'){
                this.saveFlag =true
            }else{
                this.saveFlag =false
            }
            this.delDtlArr=[]
            this.delReqArr=[]
            this.delTyArr=[]
            this.delImg=[]
            this.delPkgImg=[]
            this.delPerfData=[]
            this.delTestData=[]
            this.delTempData=[]
            this.delCertData=[]
            this.delCdfData=[]
            this.delJobData=[]
            this.formRow =JSON.parse(JSON.stringify(row ))
             
            this.v_commit =true  
            this.getDtlList(row['IDSEQ']) 
 
            this.addWin=true 
            this.loadWin =false 
        },
        //明细资料
        async getDtlList(idseq){        
            this.dtlData =[]
            this.tyData =[]
            this.matData =[]
            this.specData=[]
            this.imgData=[]
            this.perfData=[]
            this.testData=[]
            this.tempData=[]
            this.certData=[]
            this.cdfData=[]
            this.jobData=[]
            this.pkgData=[]
            this.loadWin =true
            await Promise.all([
                // 修订内容 
                this.$axios({   
                    method: 'post',
                    url:this.v_url+'',
                    data: {p_key:'idseq', p_value:idseq, p_table:'V_MAT_NOTE',p_cond: ' order by DTTM' },
                }).then(res=>{
                    this.dtlData =res.result
                }),
                // 产品清单
                this.$axios({   
                    method: 'post',
                    url:this.v_url+'',
                    data: {p_key:'idseq', p_value:idseq, p_table:'V_MAT_LIST',p_cond: ' order by LSTSEQ' },
                }).then(res=>{
                    this.matData =res.result
                }),
                //电机类型
                this.$axios({   
                    method: 'post',
                    url:this.v_url+'',
                    data: {p_key:'idseq', p_value:idseq, p_table:'V_SPEC_TYPE',p_cond: ' order by adddttm' },
                }).then(res=>{
                    this.tyData =res.result
                }),
                getTabColOrData(this.v_url,'V_SPEC_IMG','idseq',idseq,'IMGTY','SPEC').then((res) => {              
                    this.specData =res.result
                }),
                getTabColOrData(this.v_url,'V_SPEC_IMG','idseq',idseq,'IMGTY','PKG').then((res) => {              
                    this.imgData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_PERF','idseq',idseq,'','').then((res) => {              
                    this.perfData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_TEST','idseq',idseq,'','').then((res) => {              
                    this.testData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_TEMP','idseq',idseq,'','').then((res) => {              
                    this.tempData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_CERT','idseq',idseq,'','').then((res) => {              
                    this.certData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_CDF','idseq',idseq,'','').then((res) => {              
                    this.cdfData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_JOB','idseq',idseq,'','').then((res) => {              
                    this.jobData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_PACK','idseq',idseq,'','').then((res) => {              
                    this.pkgData =res.result
                }),
                getTabColOrData(this.v_url,'V_MAT_LIFE','idseq',idseq,'','').then((res) => {              
                    let v_life  =res.result
                    this.safeArr.forEach((item,index)=>{
                        let v_lifeItem =v_life.find(life=>life.CODE==item.CODE)
                        if (v_lifeItem){
                            this.safeArr.splice(index,1,Object.assign(item,{LSTSEQ:v_lifeItem.LSTSEQ,STREASON:v_lifeItem.STREASON}))
                        }else{
                            this.safeArr.splice(index,1,Object.assign(item,{LSTSEQ:'',STREASON:''}) )
                        }
                    })
                }),

            ]).catch(res=>{
                this.promptWin=true
                this.prompt=res.result
            })
            //文件修订
            this.loadWin =false
            this.$nextTick(() => {
                this.$refs['refdtl'].doLayout()     
                this.$refs['refty'].doLayout()    
                this.$refs['refreq'].doLayout() 
                this.$refs['refspec'].doLayout()    
                this.$refs['refatt'].doLayout()
                this.$refs['refperf'].doLayout()    
                this.$refs['reftest'].doLayout()
                this.$refs['reftemp'].doLayout()    
                this.$refs['refcert'].doLayout()
                this.$refs['refcdf'].doLayout()    
                this.$refs['refpkg'].doLayout()  

            })
        },
        //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='' 
            if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set STFG_SPEC=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm=''
                v_cond =' set STFG_SPEC=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗')+'?',this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_mat',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        //this.inputQry()
                        row['STFG_SPEC']=val
                        row['CHKUSER']=v_chkuser
                        row['CHKDTTM']=v_chkdttm
                    }else{
                        this.prompt =res.result
                        this.promptWin =true   
                    }    
                })
            }).catch(()=>{})           
        },

        rowClick(row){
 
        },
 
        //split-button 下拉选项
        dropSel(val){
            if (val =='expdata'){ //导出数据
                this.loadWin =true   
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'227450',p_lstseq:'2',p_json:JSON.stringify(this.tabData),p_action:'电机规格书'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = this.$LANG('1122', '电机规格书') + '_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                })          
            } else if (val =='fldset'){  //字段设置显示--隐藏
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','440642-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'440642-1',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
            }
        },

        getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','440642-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tableRef"].showColumnsByKeys(v_arr)
                    this.$refs["tableRef"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },

        setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'440642-1', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
 
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        comboChg(){
            setTimeout(() => {
                this.$refs['reftkt'].focus() 
            }, 100);
            
        },
        selChg(val){
            this.txtparam1=''
        },
 
        //字段查询
        inputQry(){
            this.queryEvent('N')
        },
        queryEvent(v_where){
            let v_cond ='' , v_oper='' ,v_edcss=''
            if (this.selparam){ //列1
                this.vueCol.some(item=>{
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.vueCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (!v_oper){
                        v_oper ='like'
                    }
                    if (v_oper =='like'){
                        v_cond =v_cond +' and upper('+item+')  like  upper(\'%'+ (this.v_row[item]).trim()+'%\')'
                    }else{
                        if (v_edcss =='number' ){
                            v_cond =v_cond +' and '+item+ v_oper + this.v_row[item]
                        }else if ( v_edcss=='date'){
                            v_cond =v_cond +' and substr('+item+',1,10)'+ v_oper +'\''+this.v_row[item] +'\''
                        }else{
                            v_cond =v_cond +' and  '+item +v_oper+'\''+ (this.v_row[item]).trim()+'\''
                        }
                    }
                }
            })
            if (v_where =='N'){
                this.getTabList(v_cond)
            }
        },
 
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.txtparam = ''
            this.oper = 'like'
            this.queryEvent('N')
        } ,
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        runRep(){
            if (!this.v_dttm ){
                this.promptWin =true
                this.prompt =this.$LANG('1777', '请选择起始完工日期')
            }else if (!this.v_todttm ){
                this.promptWin =true
                this.prompt =this.$LANG('1773', '请选择结束完工日期')
            } else{
                this.repWin =true
                this.finWin =false
                this.repUrl =this.$store.state.repUrl+ 'move_dttm.cpt'+'&p_dttm='+this.v_dttm+ '&p_todttm='+this.v_todttm
            }
        },
 
        getRowKey(row){
            return row.index
        },
   
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
            this.getFootSum()
    
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
            this.getFootSum()
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        //查询界面
        getTabList(cond){    
            this.v_loading =true
            this.tabData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {  p_key2:'corpid',p_value2:this.v_corpid, p_table:'V_BS_MAT_MOTOR',p_cond: cond +' order by '+this.selparam +' desc' },
            }).then(res=>{
                this.allList =res.result 
                this.initPage() 
                this.v_loading =false
            })    
        },
        getFootSum(){
            //累计数组中 接办数量的和
            //let v_ttlqty =this.tabData.reduce((prev,cur)=>{return Number(prev) + Number(cur.MOVEQTY) },0)
            // footer data
            // this.footerData =[
            //     {
            //         rowKey: 0,
            //         index: "合计",
            //         MOVEQTY: v_ttlqty?v_ttlqty.toLocaleString():'',
            //     },
            // ]
        } , 
 
        //获取表列头字段  v-enter-number
        getTabField(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                this.tabCol =[]
                this.vueCol =[]
                for (let k=0; k<res.result.length; k++){
                    const rowField =res.result[k]
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        holder:rowField.HOLDER,
                        sortable:rowField.SORTABLE,
                        fix:rowField.ISFIX,
                    })
                    let itcol =rowField
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            edcss:itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='number') {
                                    return (
                                        <div >
                                            <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                            </div>
                                            <div style="display:flex">
                                                <select style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                    <option value="=">=</option>
                                                    <option value=">">&gt;</option>
                                                    <option value="<">&lt;</option>
                                                    <option value="!=">!=</option>
                                                </select>
                                                <el-input disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input>
                                            </div>
                                        </div>
                                    )
                                }else{
                                    if (itcol.EDCSS=='checkbox'){
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]} on-change={()=>{this.inputQry()}}>
                                                        <el-option value="Y" label="是"></el-option>
                                                        <el-option value="N" label="否"></el-option>
                                                    </el-select>
                                                </div>
                                            </div>
                                        )
                                    }else {
                                        return (
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>
                                                </div>
                                                <div style="display:flex">
                                                    <input disabled={itcol.EDCSS=='image'} v-model={this.v_row[column.key]} on-keyup={(event)=>{if (event.key=='Enter') this.inputQry()}} on-change={()=>this.inputQry()} style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></input>
                                                </div>
                                            </div>
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.EDCSS=='image' ){
                                    return ( 
                                        <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                            <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                        </el-image>
                                    )
                                } else if (column.key=='IDNO') { //procShow(scope.row)
                                    return (
                                        <el-link title={row[itcol['key']]} on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    disableResizing: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width: 165,
                    align: "center",
                    fixed:"right",
                    disableResizing: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG_SPEC']=='Y'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.delBool} on-click={()=>{this.stfgRec(row,'N',rowIndex,'弃审')}}  underline={false} ><span style="font-size:12px;margin-right:2px;">{this.$LANG('0137', '弃审')}</span></el-link>
                                </div>                                
                            )
                        }else{
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.delBool} on-click={()=>{this.stfgRec(row,'Y',rowIndex,'审核')}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0134', '审核')}</span></el-link>
 
                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.getSetList()
            })
 
        },
        async loadTableColumns() {
            try{
                this.dtlCol = await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','2', ' order by sortby,lstseq', this.$store.state.lang )
                this.reqCol = await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','3', ' order by sortby,lstseq', this.$store.state.lang )
                this.tyCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','5', ' order by sortby,lstseq', this.$store.state.lang )
                this.specCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','6', ' order by sortby,lstseq', this.$store.state.lang )
                this.perfCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','7', ' order by sortby,lstseq', this.$store.state.lang )
                this.testCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','8', ' order by sortby,lstseq', this.$store.state.lang )
                this.tempCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','9', ' order by sortby,lstseq', this.$store.state.lang )
                this.pkgCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','10', ' order by sortby,lstseq', this.$store.state.lang )
                this.certCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','11', ' order by sortby,lstseq', this.$store.state.lang )
                this.cdfCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','12', ' order by sortby,lstseq', this.$store.state.lang )
                this.jobCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','13', ' order by sortby,lstseq', this.$store.state.lang )
                this.matCol =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','440642','lstseq','14', ' order by sortby,lstseq', this.$store.state.lang )
                this.jobArr =  await  getTab_Column(this.v_url,'v_sys_form_fld','idseq','16521','lstseq','1', ' order by sortby,lstseq', this.$store.state.lang )
            }catch(error){
                this.dtlCol =[]
                this.reqCol =[]
                this.tyCol =[]
                this.specCol =[]
                this.perfCol =[]
                this.testCol =[]
                this.tempCol =[]
                this.pkgCol =[]
                this.certCol =[]
                this.cdfCol =[]
                this.jobCol =[]
            }
        },
    }
}
</script>
<style scoped lang="less">
    .text_div {
        line-height:40px;
        font-size:12px;
        font-weight:700;
        color:black;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right:5px;
    }
    .active { 
        color:#FFF; 
        background: #389;
        border-left:3px solid #cc0000;
        margin-right:2px;
    }
    .oneTab{
        height:35px;
        line-height:31px;
        background:white;
 
    }
    .oneTab:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;  
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
 
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:66px;
    }
    .custom-button {
      background: rgb(107, 104, 104);
      font-weight:600;
      font-size:14px;
      color:#cc0000 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .custom-button:hover {
     // background: rgb(107, 104, 104);//rgb(248, 230, 230) !important;
      font-weight:600;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
     
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    /* 增大checkbox的方框大小 */
    .large-checkbox .el-checkbox__inner {
        width: 18px !important;  /* 设置方框的宽度 */
        height: 18px !important; /* 设置方框的高度 */
    }
    /* 调整对勾大小 */
    .large-checkbox .el-checkbox__inner::after {
        width: 6px !important;  /* 设置对勾的宽度 */
        height: 9px !important;  /* 设置对勾的高度 */
    }
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-range-separator {
        width: 20px !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple; 
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
 
    .el-table .default-row {
        color:black;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-table .green-row  {
        color: green;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
